import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider, App as AntdApp } from 'antd';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App.tsx';
import './index.css';
import './i18n';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Provider store={store}>
            <ConfigProvider theme={{
                token: {
                    colorPrimary: '#1677ff',
                    colorBgContainer: '#ffffff',
                }
            }}>
                <AntdApp>
                    <App />
                </AntdApp>
            </ConfigProvider>
        </Provider>
    </StrictMode>,
)
